import { GriffelStyle, tokens, typographyStyles } from "@fluentui/react-components";

export const centered: GriffelStyle = {
    display: "flex",
    marginLeft: "auto",
    marginRight: "auto"
};

export const introMobile: GriffelStyle = {
    ...typographyStyles.largeTitle,
    alignContent: "center",
    textAlign: "center",
    borderRadius: tokens.borderRadiusLarge
};

export const intro: GriffelStyle = {
    ...introMobile,
    maxWidth: "50%"
}

export const fullSpace: GriffelStyle = {
    width: "100%",
    height: "100%"
};

export const formStyle: GriffelStyle = {
    width: "100%",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: "20px",
    borderRadius: "5px",
};

export const formInputStyle: GriffelStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "2px"
};

export const formInputInlineStyle: GriffelStyle = {
    ...formInputStyle,
    flexDirection: "row",
    gap: "5px",
    alignItems: "center"
};

export const flexGrow: GriffelStyle = {
    display: "flex",
    flex: 1
};

export const flexRow: GriffelStyle = {
    display: "flex",
    flexDirection: "row",
    gap: "10px"
};

export const flexRowWrap: GriffelStyle = {
    ...flexRow,
    flexWrap: "wrap"
};

export const growFlexRow: GriffelStyle = {
    ...flexRow,
    flex: "1"
};

export const growFlexRowWrap: GriffelStyle = {
    ...growFlexRow,
    flexWrap: "wrap"
};

export const footer: GriffelStyle = {
    ...flexRow,
    position: "sticky",
    bottom: "0px",
    backgroundColor: "#333",
    flexWrap: "wrap",
    padding: "10px",
    borderRadius: "5px",
    alignItems: "center",
    justifyContent: "center"
};

export const flexColumn: GriffelStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
};

export const flexColumnWrap: GriffelStyle = {
    ...flexColumn,
    flexWrap: "wrap"
};

export const growFlexColumn: GriffelStyle = {
    ...flexColumn,
    flex: "1"
};

export const growFlexColumnWrap: GriffelStyle = {
    ...growFlexColumn,
    flexWrap: "wrap"
};

export const infoLabel: GriffelStyle = {
    display: "flex"
};

export const overflowHidden: GriffelStyle = {
    overflow: "hidden"
};

export const wrapperContent: GriffelStyle = {
    flex: "1",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderRadius: "5px",
    overflowY: "auto",

    // Chrome, Edge, Safari
    "::-webkit-scrollbar": {
      width: "12px",
      height: "12px",
    },
    "::-webkit-scrollbar-track": {
      backgroundColor: "#292929",
    },
    "::-webkit-scrollbar-thumb": {
      backgroundColor: "#888",
      borderRadius: "6px",
    },
    "::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#555",
    },

    // Firefox
    scrollbarWidth: "auto", // "auto" | "thin" | "none"
    scrollbarColor: "#888 #292929"
};

export const wrapperContentWithBackground: GriffelStyle = {
    ...wrapperContent,
    backgroundColor: tokens.colorNeutralBackground6,
    margin: "10px",
    padding: "2rem clamp(1rem, 5vw, 4rem)",
    flex: "1",
    boxSizing: "border-box",
    position: "relative"
};

export const bannerCard: GriffelStyle = {
    alignContent: "center",
    borderRadius: tokens.borderRadiusLarge,
    height: "450px",
    textAlign: "left",
    position: "relative"
};

export const drawerCollapsed: GriffelStyle = {
    width: "30px",
    backgroundColor: tokens.colorNeutralBackground4,
    height: "100%",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "10px"
};

export const drawerContent: GriffelStyle = {
    display: "flex",
    flex: 1,
    height: "100%",
    overflowX: "auto"
};